import { ScrollMapDisplayOptions, ScrollMapsFacet } from '@fullstory/page-insights-ui';

// NB: Everything here is sent from the app into the renderer iframe and back,
// and therefore can only contain data suitable for postMessage. Only the
// properties of objects / instances of classes will survive the passage;
// functions will be undefined! (Unless you are using a proxy provided by the
// channel package, e.g., using CreateClient.)

export interface ScrollMaps {
  clear();
  placeScrollMaps(scrolls: ScrollMapsFacet, displayOptions: ScrollMapDisplayOptions);
  togglePageFold(checked: boolean);
}

export interface ScrollMapsHost {
  renderStats(scrolls: ScrollMapsFacet, documentHeight?: number);
}

//
// Client stubs for auto-proxying.
// TODO(jaime): Code gen this.
export class ScrollMapsClientStub implements ScrollMaps {
  clear() {}
  placeScrollMaps(scrolls: ScrollMapsFacet, displayOptions: ScrollMapDisplayOptions) {}
  togglePageFold(checked: boolean) {}
}

export class ScrollMapsHostClientStub implements ScrollMapsHost {
  renderStats(scrolls: ScrollMapsFacet, documentHeight?: number) {}
}
